import React from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPProductDescriptionUI from './PDPProductDescriptionUI';
import PDPProductDescriptionPlaceholder from './PDPProductDescriptionPlaceholder';

const PDPProductDescriptionInner = () => {
  const {
    loading,
    error,
    data: { description, dimensions, additional_attributes },
  } = useProductAttributes();

  if (error) {
    return null;
  }

  return (
    <PDPProductDescriptionUI
      loading={loading}
      headline={description}
      dimensions={dimensions}
      description={additional_attributes?.showpiece_desc}
    />
  );
};

const PDPProductDescription = props => (
  <SuspenseWithLoader fallback={<PDPProductDescriptionPlaceholder />}>
    <PDPProductDescriptionInner {...props} />
  </SuspenseWithLoader>
);

export default PDPProductDescription;
